import '../../style/base.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/circle/style/index.js
// module id = 167
// module chunks = 31